import React from 'react'

import { ZariContext } from '_zari/context'
import { Divider, Button, Col, Row, Table } from '_zari/core'

import * as OpeOseService from 'services/operacionOse.service'

const ResumenDiarioTab = () => {
  const __zariContext = React.useContext(ZariContext)

  const [documentos, setDocumentos] = React.useState([])

  const actualizarTickets = () => {
    OpeOseService.obtenerTicketsPendientes().then(({ data }) => {
      setDocumentos(data)
    })
  }

  const clickConsultarHandler = () => {
    actualizarTickets()
  }

  const consultarDocClick = ({ ticket }) => {
    OpeOseService.actualizarEstadoxTicket(ticket)
      .then(() => {
        __zariContext.snack('success', 'El ticket se ha actualizado.')
        actualizarTickets()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }

  return (
    <>
      <Row>
        <Col md={8}>
          <Row>
            <Col md={2}>
              <Button onClick={clickConsultarHandler}>Consultar</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider noMargin />
      <Row>
        <Col md={12} className='px-4 py-2'>
          <Table.ClientSide
            filas={documentos}
            headRows={[{ label: 'DOCUMENTO' }, { label: 'TICKET' }, { label: '' }]}
            rowTemplate={row => (
              <Table.Row hover key={row.ticket}>
                <Table.Cell>{row.documento || '--'}</Table.Cell>
                <Table.Cell>{row.ticket || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='consultar-doc'
                        handleClose={handleClose}
                        onClick={e => consultarDocClick({ ticket: row.ticket })}
                      >
                        Consultar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export default ResumenDiarioTab
